import QuotationItemModel   from 'Models/sales/QuotationItemModel';
import doc                  from 'decorators/doc';
import model                from 'decorators/model';
import { Timestampable }    from 'helpers/traits';
import { Blamable }         from 'helpers/traits';
import SalesPrivateApiModel from 'modelx/models/abstracts/SalesPrivateApiModel';
import moment               from 'moment';
import { getWeekdayName }   from 'tools/Weekdays';

@model.staticLabel('QuotationItemScheduleConstraint')
@model.urnResource('quotation_item_schedule_constraint')
@doc.path('/quotation_item_schedule_constraints/{?id}')
export default class QuotationItemScheduleConstraintModel extends Blamable(Timestampable(SalesPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'quotationItem': id;
		'quotationItem.quotation': id;
	}> = {};

	public _sorts: ModelSortsExtended<unknown> = {};

	@doc.date declare endTime: Moment;
	@doc.model(QuotationItemModel) declare quotationItem: QuotationItemModel;
	@doc.date declare startTime: Moment;
	@doc.number declare weekday: number;

	public get itemId() {
		return this.get('quotationItem.id', '0');
	}

	get name() {
		return (
			getWeekdayName(this.weekday)
			+ ` de `
			+ moment(this.get('startTime'), 'HH:mm:ss').format('HH:mm')
			+ ` à `
			+ moment(this.get('endTime'), 'HH:mm:ss').format('HH:mm')
		);
	}
}